import { FacebookIcon, InstagramIcon, TwitterIcon } from '../../../../../Icon'
import { SocialMediaLinkItemProps } from './components/SocialMediaLinkItem'

export const SOCIAL_MEDIA_LINKS: SocialMediaLinkItemProps[] = [
  { icon: FacebookIcon, linkTo: 'https://facebook.com/TauromarketsOfficial/' },
  { icon: InstagramIcon, linkTo: 'https://instagram.com/tauromarkets' },
  { icon: TwitterIcon, linkTo: 'https://x.com/tauromarkets/' },
]
